import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AdminLoginModal from "../components/AdminLoginModal";
import "./SendOtp.css";
import logo from "../assets/logo_sgoolfotografie.svg";

const SendOtp = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showAdminModal, setShowAdminModal] = useState(false);
  const navigate = useNavigate();
  const { sendOtp } = useAuth();

  const handleSendOtp = async (e) => {
    e.preventDefault();

    setErrorMessage("");

    if (!email || !email.includes("@")) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }

    try {
      setLoading(true);
      const res = await sendOtp(email);

      if (res.success) {
        localStorage.setItem("otp_email", email);
        navigate("/verify-otp");
      } else {
        setErrorMessage(res.error || "Something went wrong. Please try again.");
      }
    } catch {
      setErrorMessage("Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleAdminClick = () => {
    setShowAdminModal(true);
  };

  const handleCloseModal = () => {
    setShowAdminModal(false);
  };

  return (
    <div className="otp-page">
      <button onClick={handleAdminClick} className="admin-btn-top" title="Admin Login">
        👤 Admin
      </button>

      <AdminLoginModal isOpen={showAdminModal} onClose={handleCloseModal} />

      <div className="otp-container">
        <div className="otp-header">
          <img src={logo} alt="App Logo" className="logo-img" />
          <h1>E-Mail verificatie</h1>
          <p>
            Vul uw e-mailadres in om een 6-cijferige toegangscode te ontvangen
          </p>
        </div>

        <div className="otp-form-container">
          <form onSubmit={handleSendOtp} className="otp-form">
            <div className="form-group">
              <label>
                E-Mailadres <span className="required">:</span>
              </label>
              <input
                type="email"
                placeholder="example@mail.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrorMessage("");
                }}
                required
                className={errorMessage ? "error-input" : ""}
              />
              {errorMessage && <p className="error-text">{errorMessage}</p>}

              <small>
                De 6-cijferige code wordt naar dit e-mailadres gestuurd.
                Controleer ook de spam-folder op een bericht van {" "}
                <strong>render@sgoolfotografie.nl</strong>.
              </small>
            </div>

            <button type="submit" className="btn" disabled={loading}>
              {loading ? "Sending..." : "Verstuur code"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SendOtp;
